import { LoginStage } from '../types.js'
import { LoginStages } from '../types.js'
import * as z from 'zod'

export const credentialsSchema = z.strictObject({
	userName: z.string(),
	password: z.string(),
})

export const loginRequestSchema = credentialsSchema.extend({
	stage: z.enum(LoginStages),
	mfaToken: z.string().optional(),
	newPassword: z.string().optional(),
})

export type Credentials = z.infer<typeof credentialsSchema>
export type LoginRequest = z.infer<typeof loginRequestSchema>
